/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phasepaid1Inputs */

const en_phasepaid1 = /** @type {(inputs: Phasepaid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlocked`)
};

const pt_phasepaid1 = /** @type {(inputs: Phasepaid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueado`)
};

/**
* | output |
* | --- |
* | "Unlocked" |
*
* @param {Phasepaid1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const phasepaid1 = /** @type {((inputs?: Phasepaid1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phasepaid1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phasepaid1(inputs)
	return pt_phasepaid1(inputs)
});
export { phasepaid1 as "phasePaid" }